/**
 * Efecto degauss del CRT — Fase 12b extensión.
 *
 * Reproduce el wobble cromático que producía la bobina de
 * desmagnetización al cambiar de configuración o pulsar el botón
 * DEGAUSS de un monitor CRT. Aquí se dispara cuando el usuario
 * cambia de perfil de pantalla en el selector del case.
 *
 * El efecto puro es visual (animación CSS sobre `.screen`). Para
 * "retriggar" el mismo elemento aprovechamos la técnica del reflow
 * forzado: quitar la clase, leer `offsetWidth`, volver a añadirla.
 *
 * Respeta `prefers-reduced-motion: reduce` — no aplica la clase.
 */

const DEGAUSS_CLASS = 'crt-degauss';
const DEGAUSS_ANIM = 'crt-degauss-anim';

/**
 * Dispara el degauss sobre el elemento `screen` (típicamente el
 * `<div class="screen">` del case CRT). Idempotente: cada llamada
 * reinicia la animación desde cero.
 */
export function triggerDegauss(screen: HTMLElement): void {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Re-trigger: si la clase ya está, hay que quitarla y forzar reflow
  // para que el browser arranque la animación desde cero. Sin esto,
  // un segundo cambio de perfil rápido no animaría nada.
  screen.classList.remove(DEGAUSS_CLASS);
  void screen.offsetWidth;
  screen.classList.add(DEGAUSS_CLASS);

  screen.addEventListener('animationend', function cleanup(ev) {
    const e = ev as AnimationEvent;
    if (e.animationName === DEGAUSS_ANIM) {
      screen.classList.remove(DEGAUSS_CLASS);
      screen.removeEventListener('animationend', cleanup);
    }
  });
}
